(() => {
  const initialiseCard = (card) => {
    if (card.dataset.colourCardReady === 'true') return;
    const hero = card.querySelector('[data-colour-card-hero]');
    const shadeLabel = card.querySelector('[data-colour-card-shade-label]');
    const swatches = Array.from(card.querySelectorAll('[data-colour-card-swatch]'));
    if (!hero || !swatches.length) return;

    card.dataset.colourCardReady = 'true';

    const applyShade = (swatch, force = false) => {
      if (!swatch || (!force && swatch.classList.contains('is-selected'))) return;
      const nextSrc = swatch.dataset.imageSrc;

      swatches.forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      const nextUrl = swatch.dataset.shadeUrl;
      const shadeName = (swatch.dataset.shadeName || '').trim();
      card.dataset.selectedColour = (swatch.dataset.shadeName || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      if (shadeLabel) {
        shadeLabel.textContent = shadeName;
        shadeLabel.hidden = !shadeName;
      }
      card.querySelectorAll('[data-colour-card-link]').forEach((link) => {
        if (nextUrl) link.href = nextUrl;
      });
      const heroLink = card.querySelector('.card-colour-hero-link');
      const productTitle = card.querySelector('.card__heading')?.textContent?.trim();
      if (heroLink && productTitle && swatch.dataset.shadeName) {
        heroLink.setAttribute('aria-label', `View ${productTitle} in ${swatch.dataset.shadeName}`);
      }
      const more = card.querySelector('[data-colour-card-more]');
      if (more && nextUrl) more.href = `${nextUrl}${card.dataset.colourAnchor || ''}`;

      if (nextSrc) {
        hero.classList.add('is-changing');
        const finish = () => hero.classList.remove('is-changing');
        hero.addEventListener('load', finish, { once: true });
        hero.srcset = swatch.dataset.imageSrcset || '';
        hero.src = nextSrc;
        hero.alt = swatch.dataset.imageAlt || '';
        hero.classList.toggle('card-colour-hero--extended-source', swatch.dataset.extendedPreview === 'true');
        hero.classList.toggle('card-colour-hero--compact-source', swatch.dataset.compactSource === 'true');
        hero.classList.toggle('card-colour-hero--pattern-only', swatch.dataset.patternOnly === 'true');
        hero.classList.toggle(
          'card-colour-hero--standard-source',
          swatch.dataset.extendedPreview !== 'true'
            && swatch.dataset.compactSource !== 'true'
            && swatch.dataset.patternOnly !== 'true'
        );
        if (hero.complete) window.requestAnimationFrame(finish);
      }
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => applyShade(swatch));
      swatch.addEventListener('focus', () => applyShade(swatch));
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        applyShade(swatch);
      });
    });

    const track = card.querySelector('[data-colour-card-track]');
    const previous = card.querySelector('[data-colour-card-previous]');
    const next = card.querySelector('[data-colour-card-next]');
    if (track && previous && next) {
      const updateArrows = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 1);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max;
      };
      const scroll = (direction) => {
        const swatch = track.querySelector('[data-colour-card-swatch]');
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || '8') || 8;
        const step = (swatch?.getBoundingClientRect().width || 44) + gap;
        const nextPosition = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + (direction * step * 3)));
        track.scrollLeft = nextPosition;
        window.setTimeout(updateArrows, 50);
      };
      previous.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        scroll(-1);
      };
      next.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        scroll(1);
      };
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }

    applyShade(swatches.find((swatch) => swatch.classList.contains('is-selected')) || swatches[0], true);
  };

  const initialise = (root = document) => {
    root.querySelectorAll('[data-colour-card]').forEach(initialiseCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-colour-card]')) initialiseCard(node);
        initialise(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
